export default __webpack_public_path__ + "static/media/promocionAlarma4.6513d4bd.png";